import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import mainThumbnail from '../assets/images/20241115_202429.png';
import videoThumbnail from '../assets/images/Image_fx (54).jpg';
import { db } from '../lib/firebase';
import { collection, query, where, getDocs } from 'firebase/firestore';

const Hero = () => {
  const [latestProject, setLatestProject] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showVideoModal, setShowVideoModal] = useState(false); // State for video modal

  const openVideoModal = () => setShowVideoModal(true);
  const closeVideoModal = () => setShowVideoModal(false);

  useEffect(() => {
    const fetchLatestProject = async () => {
      try {
        setIsLoading(true);
        const portfoliosRef = collection(db, 'portfolios');
        // Query for published projects only, then sort client-side
        const q = query(portfoliosRef, where('is_published', '==', true));
        const querySnapshot = await getDocs(q);
        
        if (!querySnapshot.empty) {
          // Sort on the client-side and get the latest
          const projects = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
          projects.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
          setLatestProject(projects[0]);
        } else {
          setError('No featured project found.');
        }
      } catch (err) {
        console.error("Error fetching latest project: ", err);
        setError('최신 프로젝트를 불러오는 데 실패했습니다.');
      } finally {
        setIsLoading(false);
      }
    };

    fetchLatestProject();
  }, []);

  return (
    <>
      <section data-inverse-translate="0" data-overlay-container="" data-scroll-container="" data-target-translate="-500" className="hero_home_wrap">
        <div className="hero_home_content">
          <div className="hero_home_collection hero_home_image w-dyn-list">
            <div role="list" className="hero_home_list w-dyn-items">
              <div role="listitem" className="hero_home_image w-dyn-item">
                {isLoading ? (
                  <div className="w-full h-full bg-gray-200 animate-pulse"></div>
                ) : latestProject ? (
                  <>
                    <img
                      src={latestProject.thumbnail_url} // Corrected src
                      loading="eager"
                      alt={latestProject.title}
                      className="hero_home_interior"
                    />
                    <div className="hero_home_overlay is-interior"></div>
                    <div data-translate-hero="" className="hero_home_cover">
                      <div className="hero_image_contain">
                        <img
                          src={mainThumbnail} // Corrected src
                          loading="eager"
                          width="1920"
                          height="1080"
                          alt={latestProject.title}
                          className="hero_home_facade"
                          style={{filter: 'grayscale(100%)'}}
                        />
                      </div>
                    </div>
                    <div data-overlay-scroll="" className="hero_home_overlay"></div>
                    <div className="hero_home_gradient"></div>
                    <div className="hero_collection_details u-text-small">
                      <div className="hero_collection_featured">featured project</div>
                      <div className="hero_collection_project">{latestProject.title}</div>
                      <div className="hero_collection_date">{new Date(latestProject.created_at).getFullYear()}</div>
                      <Link data-project-hover="" data-underline-hover="" data-link-hover="" to={`/project/${latestProject.id}`} className="g_link is-hero w-inline-block">
                        <div className="btn_default_contain">
                          <div data-link="" className="btn_default_text">자세히보기</div>
                        </div>
                        <div className="g_circle is-light"></div>
                      </Link>
                    </div>
                  </>
                ) : (
                  <div className="w-full h-full flex items-center justify-center bg-gray-100 text-gray-500">
                    {error || 'No project to display.'}
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="hero_home_contain">
            <div className="hero_home_bottom">
              <h1 className="hero_home_heading u-text-h4 u-sr-only">비움의 미학을 바탕으로 깨끗하고 절제된 선과 빛의 섬세한 사용, 그리고 고요하고 명상적인 분위기를 추구합니다.</h1>
              <h1 aria-hidden={true} data-lines-split="" data-split-animation="" className="hero_home_heading u-text-h4">
                비움의 미학을 바탕으로 깨끗하고 절제된 선과 빛의 섬세한 사용, 그리고 고요하고 명상적인 분위기를 추구합니다.
              </h1>
              <div className="hero_video_thumbnail" data-video-popup-trigger="" onClick={openVideoModal}>
                {videoThumbnail && (
                  <img src={videoThumbnail} alt="영상 보기" className="hero_video_image" />
                )}
                <div className="hero_video_play_button">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8 5V19L19 12L8 5Z" fill="white" />
                  </svg>
                </div>
              </div>
              <div data-split-animation="" data-lines-split="" className="hero_home_scroll u-text-transform-uppercase u-text-small">
                스크롤을 내리세요
              </div>
            </div>
          </div>
        </div>
        <div aria-hidden={true} className="hero_home_spacer"></div>
      </section>

      {/* Video Modal */}
      {showVideoModal && (
        <div className="video-modal" style={{ opacity: 1, visibility: 'visible' }}>
          <div className="video-modal-overlay" data-video-close="" onClick={closeVideoModal}></div>
          <div className="video-modal-content">
            <button className="video-modal-close" data-video-close="" onClick={closeVideoModal}>
              <span>×</span>
            </button>
            <div className="video-modal-video">
              <iframe 
                id="videoFrame" 
                width="100%" 
                height="100%" 
                src="https://www.youtube.com/embed/PPiQ9yFCmME?autoplay=1&si=g0sEMRvtQtX9c2X6" 
                frameBorder="0" 
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                allowFullScreen
                title="YouTube video player"
              ></iframe>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Hero;